(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lmp-home-principle"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('lmp-brand-film')) {
 customElements.define('lmp-brand-film', class extends HTMLElement {
  connectedCallback() {
   if (this.controller) return;
   this.controller = new AbortController();
   const signal = this.controller.signal;
   const trigger = this.querySelector('[data-film-trigger]');
   const template = this.querySelector('[data-film-template]');
   const errorMessage = this.parentElement.querySelector('[data-film-error]');
   if (!trigger || !template) return;
   trigger.addEventListener('click', event => {
    event.preventDefault();
    if (this.video) return;
    const video = template.content.querySelector('video').cloneNode(true);
    const sources = JSON.parse(this.querySelector('[data-film-sources]').textContent);
    const mp4s = sources.filter(source => source.format === 'mp4').sort((a, b) => b.height - a.height);
    const hls = sources.find(source => source.format === 'm3u8');
    const targetHeight = matchMedia('(max-width: 700px)').matches ? 720 : 1080;
    const mp4 = mp4s.find(source => source.height <= targetHeight) || mp4s[0];
    const chosen = hls && video.canPlayType('application/vnd.apple.mpegurl') ? hls : mp4;
    if (!chosen) { errorMessage.hidden = false; return; }
    video.src = chosen.url;
    const captionData = this.querySelector('[data-film-captions]');
    if (captionData && typeof VTTCue !== 'undefined') {
     const track = video.addTextTrack('subtitles', 'Deutsch', 'de');
     track.mode = 'hidden';
     JSON.parse(captionData.textContent).forEach(([start, end, text]) => {
      const cue = new VTTCue(start, end, text);
      track.addCue(cue);
     });
    }
    const fail = () => {
     if (this.video !== video) return;
     video.pause();
     video.removeAttribute('src');
     video.load();
     video.remove();
     this.video = null;
     trigger.hidden = false;
     errorMessage.hidden = false;
     trigger.focus({ preventScroll: true });
    };
    video.addEventListener('error', fail, { signal });
    this.video = video;
    errorMessage.hidden = true;
    trigger.hidden = true;
    this.append(video);
    video.focus({ preventScroll: true });
    const started = video.play();
    if (started) started.catch(error => {
     if (error.name !== 'NotAllowedError' && error.name !== 'AbortError') fail();
    });
   }, { signal });
  }
  disconnectedCallback() {
   this.controller?.abort();
   this.controller = null;
   if (this.video) {
    this.video.pause();
    this.video.removeAttribute('src');
    this.video.load();
    this.video.remove();
    this.video = null;
   }
   const trigger = this.querySelector('[data-film-trigger]');
   if (trigger) trigger.hidden = false;
  }
 });
}

if (!customElements.get('lmp-home-story-switch')) {
 customElements.define('lmp-home-story-switch', class extends HTMLElement {
  connectedCallback() {
   if (this.controller) return;
   this.controller = new AbortController();
   const signal = this.controller.signal;
   const panels = [...this.querySelectorAll('[data-home-panel]')];
   const updateTracks = () => this.querySelectorAll('[data-story-track]').forEach(track => track.dispatchEvent(new Event('scroll')));
   this.querySelectorAll('[data-home-choice]').forEach(choice => choice.addEventListener('change', updateTracks, { signal }));
   this.addEventListener('shopify:block:select', event => {
    const panel = event.target.closest('[data-home-panel]');
    if (!panel) return;
    const choice = [...this.querySelectorAll('[data-home-choice]')].find(input => input.value === panel.dataset.homePanel);
    if (choice) { choice.checked = true;updateTracks(); }
   }, { signal });
   panels.forEach(panel => {
    const track = panel.querySelector('[data-story-track]');
    const prev = panel.querySelector('[data-story-prev]');
    const next = panel.querySelector('[data-story-next]');
    const count = panel.querySelector('[data-story-count]');
    panel.querySelector('[data-story-controls]').hidden = false;
    const update = () => {
     const children = [...track.children];
     if (!children.length || !track.clientWidth) return;
     const start = track.getBoundingClientRect().left + parseFloat(getComputedStyle(track).paddingLeft);
     let closest = 0;let distance = Infinity;
     children.forEach((item, i) => { const d = Math.abs(item.getBoundingClientRect().left - start);if (d < distance) { distance = d;closest = i; } });
     count.textContent = `${closest + 1} / ${children.length}`;
     prev.disabled = track.scrollLeft <= 2;
     next.disabled = track.scrollWidth - track.clientWidth - track.scrollLeft <= 2;
    };
    track.addEventListener('scroll', update, { passive:true, signal });
    const move = direction => {
     const first = track.children[0];if (!first) return;
     const amount = first.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
     track.scrollBy({ left:amount * direction, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    };
    prev.addEventListener('click', () => move(-1), { signal });
    next.addEventListener('click', () => move(1), { signal });
    const observer = new ResizeObserver(update);observer.observe(track);
    signal.addEventListener('abort', () => observer.disconnect(), { once:true });
    update();
   });
  }
  disconnectedCallback() { this.controller?.abort();this.controller = null; }
 });
}

  } catch(e) { console.error(e); }
})();
})();
